<script setup lang="ts">
defineProps<{
  tone?: 'info' | 'success' | 'warning' | 'danger'
}>()
</script>

<template>
  <div class="status-notice" :class="tone ?? 'info'" role="status">
    <slot />
  </div>
</template>
